import { render, staticRenderFns } from "./okn_drum.config.vue?vue&type=template&id=2da6ecd2"
import script from "./okn_drum.config.vue?vue&type=script&lang=ts"
export * from "./okn_drum.config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports